var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frequency-sum"},[_c('span',[_vm._v(_vm._s(_vm.title)+" - "+_vm._s(_vm.sum)+" of "+_vm._s(_vm.numberOfTargets)+" calls")]),_c('span',{staticClass:"ml-2",class:_vm.differenceClass},[_vm._v("("+_vm._s(_vm.valueDisplayFormat.percentages(_vm.difference))+" difference)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }